import { render, staticRenderFns } from "./Skills-list-item.vue?vue&type=template&id=a847c3f6&scoped=true&lang=html"
import script from "./Skills-list-item.vue?vue&type=script&lang=js"
export * from "./Skills-list-item.vue?vue&type=script&lang=js"
import style0 from "./Skills-list-item.vue?vue&type=style&index=0&id=a847c3f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a847c3f6",
  null
  
)

export default component.exports